

export class VehicleCompanyOutputWithStatus implements IVehicleCompanyOutputWithStatus {
    /** The auto-generated id of the vehicle company master */
    vehicle_company_id!: number;
    /** The vehicle type name with 255 character limit */
    vehicle_company_name!: string;
    /** Manage status of vehicle company. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IVehicleCompanyOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_company_id = _data["vehicle_company_id"];
            this.vehicle_company_name = _data["vehicle_company_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleCompanyOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleCompanyOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_company_id"] = this.vehicle_company_id;
        data["vehicle_company_name"] = this.vehicle_company_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleCompanyOutputWithStatus {
    /** The auto-generated id of the vehicle company master */
    vehicle_company_id: number;
    /** The vehicle type name with 255 character limit */
    vehicle_company_name: string;
    /** Manage status of vehicle company. 0 For De-active, 1 For Active */
    status: number;
}

